import React from 'react';
import {
  ChartCard,
  ChartLabel,
  varCoolgray200,
  varNeutralBlack,
  varStatusSuccess200,
} from '../../../gs-component-chart';
import Icon from '@xo-union/tk-component-icons';
import { Body1, Subhead } from '@xo-union/tk-ui-typography';
import { DisplayLink, DisplayButton } from '@xo-union/tk-ui-links';
import { compose } from '@xo-union/react-css-modules';
import GdsClient from '../../../gds-api-client';

import { EventType } from '../../EventTypes';
import { Household } from '../../HouseholdTypes';
import { buildGLMUrl, buildRSVPUrl, getRSVPResponses } from './helpers';
import styles from './rsvpVisualization.scss';
interface RSVPVisualizationProps {
  isPrivateRsvp: boolean;
  events?: EventType[];
  households?: Household[];
}

export const RSVPVisualization: React.FC<RSVPVisualizationProps> = ({
  isPrivateRsvp,
  events = [],
  households = [],
}) => {
  const gdsApi = new GdsClient();

  const onDownloadAll = async (): Promise<void> => {
    const response = await gdsApi.downloadResponses();
    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'My RSVP List.csv';
    link.click();
  };

  const renderEventCharts = (): JSX.Element[] => {
    // Colors: [Accepted, Declined, No Response]
    const colors = [varStatusSuccess200, varNeutralBlack, varCoolgray200];

    const eventCharts: JSX.Element[] = events.map(
      (event): JSX.Element => {
        const eventResponses = getRSVPResponses(event.id, households);
        const glmUrl = buildGLMUrl(event.id);

        const rsvpStatsStructure = [
          { color: varStatusSuccess200, label: 'Accepted', count: eventResponses.accepted },
          { color: varNeutralBlack, label: 'Declined', count: eventResponses.declined },
          { color: varCoolgray200, label: 'No Response', count: eventResponses.noResponse },
        ];

        return (
          <div className={styles.rsvpVisualizationContainer}>
            <div className={styles.eventName}>
              <Body1 bold>{event.name}</Body1>
              <div className={styles.invitedCount}>
                <Icon name="guest_couple" />
                {eventResponses.total} Guests Invited
              </div>
            </div>
            <ChartCard
              data={rsvpStatsStructure}
              id={`rsvp-chart-${event.id}`}
              label="label"
              value="count"
              colors={colors}
            >
              <ChartLabel
                allResponded={eventResponses.noResponse === 0}
                isPrivateRsvp={isPrivateRsvp}
                responses={eventResponses.accepted + eventResponses.declined}
                total={eventResponses.total}
              />
            </ChartCard>
            <DisplayLink classes={compose({ 'tappable-area': styles.mangeGuestList })} color="primary" href={glmUrl}>
              Manage Guest List
            </DisplayLink>
          </div>
        );
      }
    );
    return eventCharts;
  };

  return (
    <>
      <div className={styles.editFormLink}>
        Edit your{' '}
        <DisplayLink color="secondary" href={buildRSVPUrl()} target="_blank" rel="noopener noreferrer">
          RSVP Page
        </DisplayLink>
      </div>
      <div className={styles.rsvpVisualizationHeader}>
        <Subhead bold>Guest responses</Subhead>
        {onDownloadAll && (
          <DisplayButton onClick={onDownloadAll} color="primary" size="md" iconName="download" labelDirection="right">
            Download all
          </DisplayButton>
        )}
      </div>

      {renderEventCharts()}
    </>
  );
};
